import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsIRCTC extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>IRCTC Related Queries</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What is IRCTC, and how is it related to RailYatri?</h3>
                            <p><span>IRCTC</span>, or the Indian Railway Catering and Tourism Corporation, is a public sector undertaking that manages the catering, hospitality, and tourism services for the Indian Railways.</p>
                            <p><span>RailYatri</span> is an authorized partner of IRCTC, providing various train-related services such as live train status, train schedules, and seat availability information. RailYatri also allows users to book train tickets and even order Food on Train. While RailYatri operates independently, it is integrated with the IRCTC for ticket booking services.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I register with IRCTC through RailYatri?</h3>
                            <li>When you attempt to book a ticket, the app will prompt you to either log in or create an IRCTC account.</li>
                            <li>If you don’t have an account, choose the <em>'Create IRCTC Account'</em> option.</li>
                            <li>Enter your personal details and verify your phone number and email address to complete the registration.</li>
                            <li>Once done, you’ll be ready to book tickets.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How can I link my IRCTC account with my RailYatri account?</h3>
                            <li>Log in to your RailYatri account by filling in your email address.</li>
                            <li>When booking, you will be prompted to link your IRCTC account.</li>
                            <li>Enter your IRCTC login details to complete the linking process.</li>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsIRCTC);
